module.exports = {"130524100":"柏乡镇","130524101":"固城店镇","130524102":"西汪镇","130524103":"龙华镇","130524200":"王家庄乡","130524203":"内步乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130524.json
// module id = 224
// module chunks = 0